import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { DepartmentArgOptions, DepartmentResMock } from '../types/department.types'
import { LocationMock } from '../types/location.type'

export const useLocation = (arg?: DepartmentArgOptions) => {
  const locationId = arg?.id
  const page = arg?.page
  const pageSize = arg?.limit
  const query = arg?.query
  let endpoint = 'locations?'

  if (page) endpoint = `${endpoint}page%5Bnumber%5D=${page}&page%5Bsize%5D=${pageSize}`
  if (query) endpoint = `${endpoint}&query=${query}`

  const { data: location, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<DepartmentResMock<LocationMock[]>>(endpoint)
      return data
    },
    queryKey: ['location', locationId, page, pageSize, query]
  })

  const { data: singleLocation } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get(`locations/${locationId}`)
      return data.data
    },
    queryKey: ['location', locationId]
  })

  const { mutateAsync: addLocation } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`locations`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['location'] })
  })

  const { mutateAsync: updateLocation } = useMutation({
    mutationFn: async ({ data, id }: { data: any; id: string }) => {
      await AXIOS_INSTANCE.patch(`locations/${id}`, data, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['location'] })
  })

  const { mutateAsync: deleteLocation } = useMutation({
    mutationFn: async (id: string) => {
      await AXIOS_INSTANCE.delete(`locations/${id}`)
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['location'] })
  })

  return {
    addLocation,
    deleteLocation,
    isLoading,
    locationPagination: location?.meta?.pagination,
    locations: location?.data,
    singleLocation,
    updateLocation
  }
}
